<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialogVisible"
      style="overflow-x: auto"
      :max-width="selectedItemType === 1 ? 1200 : selectedItemType === 3 ? 700 : 500"
      :persistent="$store.state.loading">
      <v-card>
        <v-card :loading="$store.state.loading" style="position: sticky; top: 0; z-index: 1000" tile>
          <v-toolbar class="v-sheet theme--dark v-toolbar secondary">
            <v-btn v-if="selectedItemType" dark icon @click="resetSelectedItemType()">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title>
              {{ title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark icon @click="closeAddItemModal()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card>
        <v-card tile>
          <v-container>
            <v-row class="mt-4" v-if="!selectedItemType">
              <v-col cols="12">
                <h3>Please select the item type below you want to add.</h3>
              </v-col>
              <v-col cols="12">
                <span>
                  <v-tooltip :disabled="canSellTaxis" color="black" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-on="on" v-bind="attrs">
                        <v-btn
                          @click="handleTaxiClick"
                          :disabled="!canSellTaxis"
                          color="#2b2b2b"
                          class="mr-2"
                          style="color: #fec33a"
                          >Taxi
                        </v-btn>
                      </span>
                    </template>
                    <span>Tenant {{ tenantName }} is not allowed to sell taxis.</span>
                  </v-tooltip>
                </span>
                <span>
                  <v-tooltip :disabled="canUseGiftcard" color="black" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-on="on" v-bind="attrs">
                        <v-btn
                          style="background-color: rgb(112, 163, 127); border-color: rgb(112, 163, 127)"
                          @click="handleAddItemTypeClick(2)"
                          :disabled="!canUseGiftcard"
                          class="mr-2 white--text"
                          >Gift Card
                        </v-btn>
                      </span>
                    </template>
                    <span>Tenant {{ tenantName }} is not allowed to sell gift cards.</span>
                  </v-tooltip>
                </span>
                <v-btn
                  style="background-color: rgb(93, 145, 232); border-color: rgb(93, 145, 232)"
                  @click="handleAddItemTypeClick(3)"
                  class="mr-2 white--text"
                  >Article
                </v-btn>
                <v-btn
                  style="background-color: rgb(134, 146, 197); border-color: rgb(134, 146, 197)"
                  @click="handleAddItemTypeClick(4)"
                  class="mr-2 white--text"
                  >Distribution
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <!-- Slot for Gift Card Form -->
              <v-col cols="12" v-if="keepTaxiWidgetAlive" v-show="selectedItemType === 1">
                <slot name="taxi" />
              </v-col>
              <!-- Slot for Gift Card Form -->
              <v-col cols="12" v-if="selectedItemType === 2">
                <slot name="gift-card" />
              </v-col>
              <!-- Slot for Article Form-->
              <v-col cols="12" v-if="selectedItemType === 3">
                <slot name="article" />
              </v-col>
              <!-- Slot for Distribution Form -->
              <v-col cols="12" v-if="selectedItemType === 4">
                <slot name="distribution" />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "AddNewItemModal",
  data() {
    return {
      title: "Add New Item",
      keepTaxiWidgetAlive: false,
    };
  },
  props: {
    selectedItemType: {
      type: Number,
      default: null,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    canUseGiftcard: {
      type: Boolean,
      default: false,
    },
    tenantName: {
      type: String,
      default: "",
    },
    canSellTaxis: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dialogVisible(value) {
      if (value) {
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
        setTimeout(() => {
          this.resetSelectedItemType();
        }, 200);
      }
    },
  },
  computed: {
    dialogVisible: {
      get() {
        // this is a fix to prevent visual glitch when closing modal
        setTimeout(() => {
          this.selectedItemType = null;
        }, 300);
        return this.isVisible;
      },
      set(value) {
        this.$emit("update:isVisible", value);
      },
    },
  },
  methods: {
    closeAddItemModal() {
      this.$emit("update:isVisible", false);
    },
    handleAddItemTypeClick(itemType) {
      switch (itemType) {
        case 1:
          this.title = "Add New Taxi";
          break;
        case 2:
          this.title = "Add New Gift Card";
          break;
        case 3:
          this.title = "Add New Article";
          break;
        case 4:
          this.title = "Add New Distribution";
          break;
        default:
          break;
      }
      this.$emit("update:selectedItemType", itemType);
    },
    resetSelectedItemType() {
      this.$emit("update:selectedItemType", null);
      this.title = "Add New Item";
    },
    handleTaxiClick() {
      this.keepTaxiWidgetAlive = true;
      this.handleAddItemTypeClick(1);
    },
  },
};
</script>
